module.exports = __webpack_public_path__ + "static/media/nd1.3d3ede9e.jpg";